import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { anularInicioLlenado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarInicioDeLlenadoView } from '../components/OperacionEliminarInicioDeLlenadoView'

export const OperacionEliminarInicioDeLlenado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarInicioDeLlenadoView
        silo={silo}
        aceptar={async () => {
          try {
            await anularInicioLlenado(silo)
            closeDialog()
            enqueueSnackbar('Anulado de inicio correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de inicio incorrecto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ANULAR_INICIO_LLENADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
